var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img"},[_c('img',{staticClass:"img",attrs:{"src":'/MiddleImg/'+ _vm.image,"alt":"..."}})])}
var staticRenderFns = []

export { render, staticRenderFns }